import { render, staticRenderFns } from "./MoleculeEditionAssetContentComments.vue?vue&type=template&id=022c88f1"
import script from "./MoleculeEditionAssetContentComments.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionAssetContentComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports